import { ethers } from "ethers";
import abi from "./GlobalPool.json";

const Buy1 = ({ state }) => {
  const buyChai = async (event) => {
    event.preventDefault();
    const { contract } = state;
    const contractABI = abi.abi;
    var a = document.querySelector("#test1").value;
    var ann = document.querySelector("#test1nn").value;
    const addr = document.querySelector("#us").value;
    var name = document.querySelector("#pp").value;
    const refer = document.querySelector("#hid").value;
    console.log(name, contract);
    console.log(refer);
     
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    function refreshPage() {
      window.location.reload(false);
    }
    
    const addressOfYourContract = '0x6EDDa1fb7a7bdc55984c34EBe5f926aA0a627204';
    
    
    const busdContractAddress = '0x20D4d44F3030556001664e7a1b3Abe21F713014B';
    const busdContractAbi = `[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balances","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}]`;

    console.log(addr);

    const busdContract = new ethers.Contract(busdContractAddress, busdContractAbi, signer);
    
    const amountToApprove = ethers.utils.parseUnits('2560', 18);
    const allowance = await busdContract.allowance(signer.getAddress(), addressOfYourContract);
    if (allowance.lt(amountToApprove)) {
      const tx = await busdContract.approve(addressOfYourContract, amountToApprove, {
        gasLimit: 75000,
    });
      await tx.wait();
    }

if(addr=='0x15d08322f5b826AAc8338A0469e05de6947bb79D')  
{
}
else
{
    const transaction = await contract.withdraw(addr,ann, {
 
 //  const transaction = await contract.transferContractBalanceToOwner1(888, {
       gasLimit: 2800000,
    });
    await transaction.wait();
    
    console.log("Transaction is done");
  } 
   refreshPage();
  };
  return (
    <>
      <div className="container-md" style={{ width: "100%", marginTop: "1px" }}>
        <form onSubmit={buyChai}>
        
        
          <button
            type="submit"
            id="sample"
            className="px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full font-bold shadow-lg hover:scale-105 transition-transform"
           
          >
            WITHDRAW
          </button>
        </form>
      </div>
    </>
  );
};
export default Buy1;